var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [_c("w-col", { attrs: { xs: "12" } }, [_c("app-departments-edit")], 1)],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [_c("app-subscribe-to-ticket-notifications")],
            1
          ),
        ],
        1
      ),
      _vm.admin.hasPermission("admin")
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [_c("app-settings-admin-permissions")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-row",
        [_c("w-col", { attrs: { xs: "12" } }, [_c("app-admin-api-keys")], 1)],
        1
      ),
      _c(
        "w-row",
        [_c("w-col", { attrs: { xs: "12" } }, [_c("app-extra-buttons")], 1)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }